import { applicationApi } from "../../../common/api";
import { History, SubmissionForm, SubmissionFormWrapper, SubmissionList } from "./types";

// Define a service using a base URL and expected endpoints
export const loanSubmissionApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLoanSubmission: builder.query<SubmissionList[], void>({
      query: () => `loans-submission/data`,
      providesTags: [{ type: 'LoanSubmission', id: 'LIST' }],
    }),
    getLoanSubmission: builder.query<SubmissionFormWrapper, string>({
      query: (query) => `loans-submission/data/${query}`,
      providesTags: [{ type: 'LoanSubmission', id: 'LIST' }],
    }),
    getLoanSubmissionHistory: builder.query<History[], any>({
      query: (params) => ({
        url: '/loans-submission/data/history',
        method: 'GET',
        params: params,
      }),
      providesTags: [{ type: 'LoanSubmission', id: 'LIST' }, { type: 'LoanSubmissionHistory' }],
    }),
    createLoanSubmission: builder.mutation<SubmissionForm, any>({
      query: (body) => ({
        url: 'loans-submission/data',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'LoanSubmission', id: 'LIST' }],
    }),
    updateLoanSubmission: builder.mutation<SubmissionForm, any>({
      query: (body) => ({
        url: 'loans-submission/data',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'LoanSubmission', id: 'LIST' }, { type: 'LoanSubmissionHistory' }],
    }),
    updateLoanSubmissionStatus: builder.mutation<SubmissionForm, any>({
      query: (body) => ({
        url: 'loans-submission/data/status',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'LoanSubmission', id: 'LIST' }, { type: 'LoanSubmissionHistory' }],
    }),
    approveLoanSubmissionStatus: builder.mutation<any, any>({
      query: (body) => ({
        url: 'loans-submission/data/approve',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'LoanSubmission', id: 'LIST' }, { type: 'LoanSubmissionHistory' }],
    }),
    verifyLoanSubmission: builder.mutation<void, any>({
      query: (body) => ({
        url: 'loans-submission/data/verify',
        method: 'PATCH',
        params: body,
      }),
      invalidatesTags: [{ type: 'LoanSubmission', id: 'LIST' }, { type: 'LoanSubmissionHistory' }],
    }),
    uploadAgreementDocument: builder.mutation<void, any>({
      query: (body) => ({
        url: 'loans-submission/data/upload-agreement',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'LoanSubmission', id: 'LIST' }, { type: 'LoanSubmissionHistory' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateLoanSubmissionMutation,
  useGetAllLoanSubmissionQuery,
  useGetLoanSubmissionQuery,
  useUpdateLoanSubmissionMutation,
  useUpdateLoanSubmissionStatusMutation,
  useApproveLoanSubmissionStatusMutation,
  useGetLoanSubmissionHistoryQuery,
  useVerifyLoanSubmissionMutation,
  useUploadAgreementDocumentMutation,
} = loanSubmissionApi;
